var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.selectedRelease
    ? _c("div", { staticClass: "menu-position" }, [
        _c("div", { staticClass: "tools-strip" }, [
          _c(
            "button",
            {
              staticClass: "tool-btn",
              class: { "tool-btn--active": _vm.extentsPanelOpen },
              attrs: { title: "Change Extent" },
              on: { click: _vm.toggleExtentsPanel },
            },
            [
              _c("fa", {
                attrs: { icon: ["fas", "globe-americas"], size: "sm" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "tool-btn",
              class: { "tool-btn--active": _vm.baseMapsPanelOpen },
              attrs: { id: "base-maps", title: "Switch Base Map" },
              on: { click: _vm.toggleBaseMapsPanel },
            },
            [_c("fa", { attrs: { icon: ["fas", "map"], size: "sm" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "tool-btn",
              class: {
                "tool-btn--active": _vm.lidarToggle,
                "tool-btn--warn": !_vm.lidarMinZoomAchieved,
              },
              attrs: { title: "2D Lidar" },
              on: { click: _vm.toggleLidar },
            },
            [
              _c("fa", {
                attrs: {
                  icon: [
                    "fas",
                    _vm.lidarMinZoomAchieved
                      ? "layer-group"
                      : "exclamation-triangle",
                  ],
                  size: "sm",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "tool-btn",
              class: { "tool-btn--active": _vm.measuringToolOn },
              attrs: { title: "Measuring Tool" },
              on: { click: _vm.toggleMeasure },
            },
            [_c("fa", { attrs: { icon: ["fas", "ruler"], size: "sm" } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tools-popup-area" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.extentsPanelOpen,
                  expression: "extentsPanelOpen",
                },
              ],
              staticClass: "tools-popup",
            },
            [
              _c("Generic_CollapsedExtents", {
                attrs: {
                  map: _vm.map,
                  selectedExtent: _vm.selectedExtent,
                  userOrg: _vm.user ? _vm.user.org : null,
                },
                on: { extentChanged: _vm.onExtentChanged },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.baseMapsPanelOpen,
                  expression: "baseMapsPanelOpen",
                },
              ],
              staticClass: "tools-popup",
            },
            [
              _c("MMP_CollapsedBaseMap", {
                attrs: {
                  currentBaseMap: _vm.currentBaseMap,
                  expanded: _vm.baseMapsPanelOpen,
                  map: _vm.map,
                  isAnsiComponent: false,
                },
                on: {
                  toggleBaseLayer: function ($event) {
                    return _vm.$emit("toggleBaseLayer", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.lidarToggle,
                  expression: "lidarToggle",
                },
              ],
              staticClass: "lidar-popup",
            },
            [
              _c("Generic_LidarTiles", {
                attrs: {
                  showLidarPanel: _vm.lidarToggle,
                  lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
                  distinct_lidar: _vm.distinct_lidar,
                  lidarIsLoading: _vm.lidarIsLoading,
                  map: _vm.map,
                  selectedExtent: _vm.selectedExtent,
                  zoomLevel: _vm.zoomLevel,
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }